export default value => typeof value === 'object';
